var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 3H12C7.02944 3 3 7.02944 3 12V36C3 40.9706 7.02944 45 12 45H36C40.9706 45 45 40.9706 45 36V12C45 7.02944 40.9706 3 36 3Z",
    fill: "url(#paint0_radial_4362_9231)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3H12C7.02944 3 3 7.02944 3 12V36C3 40.9706 7.02944 45 12 45H36C40.9706 45 45 40.9706 45 36V12C45 7.02944 40.9706 3 36 3Z",
    fill: "url(#paint1_radial_4362_9231)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3H12C7.02944 3 3 7.02944 3 12V36C3 40.9706 7.02944 45 12 45H36C40.9706 45 45 40.9706 45 36V12C45 7.02944 40.9706 3 36 3Z",
    fill: "url(#paint2_radial_4362_9231)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 15.75C34.5 16.9926 33.4926 18 32.25 18C31.0074 18 30 16.9926 30 15.75C30 14.5074 31.0074 13.5 32.25 13.5C33.4926 13.5 34.5 14.5074 34.5 15.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 31.5C28.1421 31.5 31.5 28.1421 31.5 24C31.5 19.8579 28.1421 16.5 24 16.5C19.8579 16.5 16.5 19.8579 16.5 24C16.5 28.1421 19.8579 31.5 24 31.5ZM24 28.5C26.4853 28.5 28.5 26.4853 28.5 24C28.5 21.5146 26.4853 19.5 24 19.5C21.5146 19.5 19.5 21.5146 19.5 24C19.5 26.4853 21.5146 28.5 24 28.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 23.4C9 18.3596 9 15.8393 9.98094 13.9141C10.8438 12.2206 12.2206 10.8438 13.9141 9.98094C15.8393 9 18.3596 9 23.4 9H24.6C29.6404 9 32.1607 9 34.0858 9.98094C35.7794 10.8438 37.1562 12.2206 38.019 13.9141C39 15.8393 39 18.3596 39 23.4V24.6C39 29.6404 39 32.1607 38.019 34.0858C37.1562 35.7794 35.7794 37.1562 34.0858 38.019C32.1607 39 29.6404 39 24.6 39H23.4C18.3596 39 15.8393 39 13.9141 38.019C12.2206 37.1562 10.8438 35.7794 9.98094 34.0858C9 32.1607 9 29.6404 9 24.6V23.4ZM23.4 12H24.6C27.1698 12 28.9165 12.0023 30.2668 12.1126C31.5822 12.2201 32.2548 12.4149 32.724 12.654C33.8529 13.2292 34.7707 14.1471 35.346 15.276C35.5851 15.7452 35.7799 16.4178 35.8874 17.7331C35.9976 19.0834 36 20.8302 36 23.4V24.6C36 27.1698 35.9976 28.9165 35.8874 30.2668C35.7799 31.5822 35.5851 32.2548 35.346 32.724C34.7707 33.8529 33.8529 34.7707 32.724 35.346C32.2548 35.5851 31.5822 35.7799 30.2668 35.8874C28.9165 35.9976 27.1698 36 24.6 36H23.4C20.8302 36 19.0834 35.9976 17.7331 35.8874C16.4178 35.7799 15.7452 35.5851 15.276 35.346C14.1471 34.7707 13.2292 33.8529 12.654 32.724C12.4149 32.2548 12.2201 31.5822 12.1126 30.2668C12.0023 28.9165 12 27.1698 12 24.6V23.4C12 20.8302 12.0023 19.0834 12.1126 17.7331C12.2201 16.4178 12.4149 15.7452 12.654 15.276C13.2292 14.1471 14.1471 13.2292 15.276 12.654C15.7452 12.4149 16.4178 12.2201 17.7331 12.1126C19.0834 12.0023 20.8302 12 23.4 12Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4362_9231",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 34.5) rotate(-55.3758) scale(38.2794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4362_9231",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 46.5) rotate(-65.1363) scale(33.8913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4362_9231",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.750001 4.5) rotate(-8.1301) scale(58.3364 12.4775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.acfb432e1eef302e02813cee0ea7c3dd.svg";
export { ForwardRef as ReactComponent };